import React from 'react';
import { resolveMedia } from '../lib/media';

// Estrae l'ID YouTube da URL youtu.be / watch?v= / shorts / embed
export const getYoutubeId = (url) => {
  if (!url) return null;
  const m = String(url).match(/(?:youtube\.com\/(?:shorts\/|watch\?v=|embed\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{6,20})/);
  return m ? m[1] : null;
};

const FeaturedVideo = ({ url, title }) => {
  if (!url) return null;
  const ytId = getYoutubeId(url);

  return (
    <section className="px-4 pt-6 sm:pt-8" style={{ backgroundColor: 'var(--tp-black)' }} data-testid="featured-video-section">
      <div className="max-w-4xl mx-auto flex flex-col items-center">
        {title && (
          <p
            className="text-center text-white font-bold text-xs sm:text-sm md:text-base tracking-widest mb-2 sm:mb-3"
            style={{ fontFamily: 'Oswald, sans-serif', letterSpacing: '2px' }}
            data-testid="featured-video-title"
          >
            {title}
          </p>
        )}
        <div
          className="relative w-full bg-black rounded-xl overflow-hidden border border-red-600/40 shadow-2xl"
          style={{ aspectRatio: '16 / 9' }}
        >
          {ytId ? (
            <iframe
              src={`https://www.youtube.com/embed/${ytId}?autoplay=1&mute=1&loop=1&playlist=${ytId}&controls=1&modestbranding=1&rel=0&playsinline=1`}
              title={title || 'Tecniche Perfette — Video'}
              data-testid="featured-video-youtube"
              className="absolute inset-0 w-full h-full"
              style={{ border: 0 }}
              allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              loading="eager"
            />
          ) : (
            <video
              src={resolveMedia(url)}
              data-testid="featured-video-mp4"
              className="absolute inset-0 w-full h-full object-contain"
              controls
              autoPlay
              muted
              loop
              playsInline
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default FeaturedVideo;
